import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/selling-on-depop';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling On Depop? 10 Effective Tips for Listing on Depop</title>
        <meta
          name='description'
          content="Selling on online marketplaces like Depop can be part-time work for some. After all, selling on the internet is proven to be convenient. But even if it is only a side hustle to you, you can always take it more seriously to increase earnings. Simply posting photos and stating what kind of item you are offering are not enough. Potential buyers tend to flock to attractive listings, especially when they have great descriptions, are written under the right category, and have effective keywords. We have listed down effective ways to describe your item's listing and be one of the top sellers on Depop."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/selling-on-depop' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/selling-on-depop' />
        <meta property='og:title' content='Selling On Depop? 10 Effective Tips for Listing on Depop' />
        <meta
          property='og:description'
          content="Selling on online marketplaces like Depop can be part-time work for some. After all, selling on the internet is proven to be convenient. But even if it is only a side hustle to you, you can always take it more seriously to increase earnings. Simply posting photos and stating what kind of item you are offering are not enough. Potential buyers tend to flock to attractive listings, especially when they have great descriptions, are written under the right category, and have effective keywords. We have listed down effective ways to describe your item's listing and be one of the top sellers on Depop."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
